import { render, staticRenderFns } from "./searchPerson.vue?vue&type=template&id=622721bc&scoped=true"
import script from "./searchPerson.vue?vue&type=script&lang=js"
export * from "./searchPerson.vue?vue&type=script&lang=js"
import style0 from "./searchPerson.vue?vue&type=style&index=0&id=622721bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622721bc",
  null
  
)

export default component.exports